module.exports = __webpack_public_path__ + "img/bbb.9f7a15dc.gif";